import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  email?: string;
  password?: string;
  name?: string;

  @Output() register = new EventEmitter<void>();
  @Output() return = new EventEmitter<void>();

  constructor(
    private userService: UserService,
    public sharedService: SharedService
  ) {}

  ngOnInit(): void {}

  registerUser(): void {
    // register user
    this.userService
      .register(this.email, this.password, this.name)
      .then((userUid: string) => {
        // then sign in
        this.userService
          .signIn('email', { email: this.email, password: this.password })
          .then(() => {
            // update user name
            this.userService
              .updateUser(userUid, { name: this.name })
              // then emit registration
              .then(() => this.register.emit());
          });
      });
  }
}
